import React, { Component } from 'react'
import InputTextB from '../../customComponents/inputTextB'
import { InputText } from 'primereact/inputtext'
import { FIELDS_INFO } from '../../../constants'
import _, { cloneDeep, constant } from 'lodash';
import Service from './../../services';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect'
import { DataTable } from 'primereact/datatable'
import { Button } from 'primereact/button'
import { Checkbox } from 'primereact/checkbox'
import { Dialog } from 'primereact/dialog'
import { connect } from 'react-redux';
import { getPermissionList, getSelectedModules } from '../../../store/actions/getPermissionsAction';
import { addRole, updateAddRolesRequest } from '../../../store/actions/rolesAction';
import { selectPermissions } from '../../../store/selectors/authorize';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { getFormFields, isFormValid, onDropDownChange, onTextChange } from '../../../utile/formHelper';
import { trimObj } from '../../../utile';
import { AcademicSessionCalIcon, AssignFormIcon, MailIcon } from '../../svgIcons';
import ClassetMultiSelect from "../../../classetComponents/classetMultiSelect";
import ClassetInputText from '../../../classetComponents/classetInputText';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import { Toast } from 'primereact/toast';
import { CookieStorage } from 'amazon-cognito-identity-js';
import { CodeStarNotifications } from 'aws-sdk';
import LoadingComponent from '../../loadingComponent';
import ClassetDropdown from '../../../classetComponents/classetDropDown';

const createRoleFields = require('./createRole.json');
const TemplateTypes = [{ label: 'Admin', value: 'admin' }, { label: 'Teacher', value: 'teacher' }, { label: 'Counsellor', value: 'counsellor' }]

const mobileFeatures = [
    {
        category: 'Dashboard Options',
        description: 'Features accessible from the main dashboard view',
        features: [
            {
                id: 'attendance',
                name: 'Attendance',
                description: 'Allows viewing and managing attendance data',
                hasSubFeatures: true,
                subFeatures: [
                    {
                        id: 'mark_attendance',
                        name: 'Mark Attendance',
                        description: 'Permits marking attendance for students',
                        autoEnabled: true
                    }
                ]
            },
            {
                id: 'finance',
                name: 'Finance',
                description: 'Access to financial reports and fee management',
                hasSubFeatures: false
            },
            {
                id: 'transport',
                name: 'Transport',
                description: 'View transport routes, schedules, and student assignments',
                hasSubFeatures: false
            },
            {
                id: 'subjective_exams',
                name: 'Subjective Exams',
                description: 'View and manage subjective exams',
                hasSubFeatures: false
            },
            {
                id: 'alerts',
                name: 'Alerts',
                description: 'Receive and manage system notifications',
                hasSubFeatures: true,
                subFeatures: [
                    {
                        id: 'send_alerts',
                        name: 'Send Alerts',
                        description: 'Send Alerts To Parents And Students',
                        autoEnabled: true
                    },
                    {
                        id: 'create_notification',
                        name: 'Create notification',
                        description: 'Creating an alert in the system',
                        autoEnabled: true
                    }
                ]
            },
            {
                id: 'view_admissions',
                name: 'Admissions',
                description: 'Manage admissions process and student applications',
                hasSubFeatures: true,
                subFeatures: [
                    {
                        id: 'create_admission',
                        name: 'Create Admission',
                        description: 'Create new admission enquiries',
                        autoEnabled: true
                    },
                    {
                        id: 'update_admission',
                        name: 'Update Admission',
                        description: 'Edit admission details at any stage',
                        autoEnabled: true
                    },
                    {
                        id: 'proceed_admission',
                        name: 'Proceed to Next Stage',
                        description: 'Advance admission through stages',
                        autoEnabled: true
                    },
                    {
                        id: 'delete_admission',
                        name: 'Delete Admission',
                        description: 'Drop-off or remove admission records',
                        autoEnabled: true
                    },
                    {
                        id: 'admission_payment',
                        name: 'Admission Payment',
                        description: 'Process admission-related fee payments',
                        autoEnabled: true
                    }
                ]
            }
        ]
    },
    {
        category: 'Approvals',
        description: 'Administrative approval workflows and processes',
        features: [
            {
                id: 'student_status_change',
                name: 'Student Status Change',
                description: 'Approve changes to student enrollment status',
                hasSubFeatures: false
            },
            {
                id: 'fee_concession',
                name: 'Fee Concession',
                description: 'Review and approve fee concession requests',
                hasSubFeatures: false
            },
            {
                id: 'fee_unassign',
                name: 'Fee Unassign',
                description: 'Approve removal of fee assignments',
                hasSubFeatures: false
            },
            {
                id: 'fee_refund',
                name: 'Fee Refund',
                description: 'Process and approve fee refund requests',
                hasSubFeatures: false
            },
            {
                id: 'assign_transport',
                name: 'Assign Transport',
                description: 'Approve transport assignments for students',
                hasSubFeatures: false
            },
            {
                id: 'routes_approvals',
                name: 'Routes Approvals',
                description: 'Approve new transport route requests',
                hasSubFeatures: false
            },
            {
                id: 'stop_approvals',
                name: 'Stop Approvals',
                description: 'Approve new bus stop requests',
                hasSubFeatures: false
            },
            {
                id: 'timetable_requests',
                name: 'Timetable Requests',
                description: 'Review and approve timetable modification requests',
                hasSubFeatures: false
            }
        ]
    }
];

let formFields = createRoleFields;
const parsePermissionsData = (permissions) => {

    let selectedPermissions = {};

    Object.keys(permissions).forEach((permissionGroupId) => {
        selectedPermissions[permissionGroupId] = [];
        permissions[permissionGroupId].permissions.forEach(selectedPermissionObj => {
            selectedPermissions[permissionGroupId].push(selectedPermissionObj.id);
        })
    });

    return selectedPermissions;
};

class CreateRoleManagement extends Component {

    constructor(props) {
        super(props);
        this.formFields = getFormFields(formFields, this.props.editRoleData || {});

        this.state = {
            currentTab: this.props.currentTab,
            selectedModule: this.props.permissionsMasterList && this.props.permissionsMasterList.length > 0
                ? this.props.permissionsMasterList[0]._id
                : '',
            role: this.formFields.data,
            formValidations: this.formFields.formValidations,
            permissions: parsePermissionsData((this.props.editRoleData && this.props.editRoleData.permissions) ? this.props.editRoleData.permissions : {}),
            errors: {},
            permissionsMasterList1: [],
            summary: null,
            isShowCreateOrUpdateSuccessDlg: false,
            permissionIds: [],
            editModules: this.props.editModules || [],
            isAdd: this.props.isAdd,
            filterData: [],
            labelOptions: [],
            isLoading: false,
            showMobilePermissionsModal: false,
            adminMobileAppPermissions: (this.props.editRoleData && this.props.editRoleData.adminMobileAppPermissions) || [],
            selectedMobilePermissions: new Set((this.props.editRoleData && this.props.editRoleData.adminMobileAppPermissions) || []),
            expandedSections: { 'Dashboard Options': true, 'Approvals': true }, // Keep both sections expanded by default
            isModalMaximized: false
        }

        this.service = new Service();
    }



    getPermissionListByGroup = (groupId) => {
        const { permissionsMasterList } = this.props;
        const groupedPermissions = permissionsMasterList.find((item) => item.id === groupId);
        return groupedPermissions;
    };
    onSubmitClick = () => {
        // const academicYear = localStorage.getItem("userAcademicYear")
        let { permissions } = this.state;

        let role = this.state.role;


        if (permissions && Object.keys(permissions).length) {
            Object.keys(permissions).forEach(key => {
                if (!(permissions[key] && permissions[key].length)) {
                    delete permissions[key];
                }
            })
        }
        if (Object.keys(permissions).length === 0) {
            return this.toast.show({ severity: 'error', summary: 'Atleast one permission should assign', life: 3000 });
        }

        // Validate mobile app permissions are mandatory
        if (this.state.selectedMobilePermissions.size === 0) {
            return this.toast.show({
                severity: 'error',
                summary: 'Mobile App Permissions Required',
                detail: 'Please configure at least one mobile app permission before saving the role',
                life: 4000
            });
        }

        role.permissions = permissions;

        role = trimObj(role);
        const formStatus = isFormValid(formFields, this.formFields.formValidations, role);

        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations,
            });
        } else {

            const permissionOrderedByGroups = Object.keys(permissions)?.reduce((acc, curr) => {
                const groupedPermissions = this.getPermissionListByGroup(curr);

                if (groupedPermissions) {
                    const perms = permissions[curr].map((permId) => {
                        return groupedPermissions.permissions.find((permObject) => {
                            if (permObject.id === permId) {
                                return permObject;
                            }
                        });
                    });

                    acc[curr] = {
                        groupName: groupedPermissions.groupName,
                        permissions: perms.filter((item) => item !== undefined)
                    };
                }
                return acc;
            }, {});

            role = trimObj(role);
            const payload = {
                ...role,
                // academicYear: academicYear,
                permissions: permissionOrderedByGroups,
                adminMobileAppPermissions: Array.from(this.state.selectedMobilePermissions)
            };


            this.setState({
                isLoading: true
            })


            if (!this.props.isAdd) {


                const url = `${baseUrlAdmin}/authorize/addRole`;
                this.service.post(url, payload, true).then(res => {
                    if (res && res.status) {


                        let summary = this.getSummaryReport(this.state.permissionsMasterList1, payload)

                        this.toast.show({ severity: 'success', summary: 'Role Created Successfully', detail: `${summary.roleName}`, life: 3000 });
                        this.setState({
                            isLoading: false,
                            summary,
                            isShowCreateOrUpdateSuccessDlg: true,
                            isCreated: true

                        }, () => {
                            //this.props.getPermissions()
                            this.props.getApiCall(true)
                            this.props.getRoles()
                            this.props.onTabChange(0);

                        })

                    } else {
                        this.setState({
                            isLoading: false
                        }, () => {
                            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                        });
                    }
                }).catch(e => {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
                    console.log(e);
                })
            } else {

                const url = `${baseUrlAdmin}/authorize/updateRole`;

                this.service.put(url, { ...payload }, true).then((res) => {
                    if (res && res.status) {
                        let summary = this.getSummaryReport(this.state.permissionsMasterList1, payload)

                        this.toast.show({ severity: 'success', summary: 'Role Updated Successfully', detail: `${summary.roleName}`, life: 3000 });

                        this.setState({
                            isLoading: false,
                            summary,
                            isShowCreateOrUpdateSuccessDlg: true,
                            isCreated: true
                        }, () => {
                            this.props.getApiCall(true)
                            this.props.getRoles()
                            this.props.onTabChange(0);
                        });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                    }
                }).catch(e => {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
                });

            }


        }

    };

    componentDidMount() {

        if (this.props.permissionsMasterList && Array.isArray(this.props.permissionsMasterList) && this.props.permissionsMasterList.length > 0) {
            this.setState({
                permissionsMasterList1: this.props.permissionsMasterList
            }, () => {
                this.getLabelOptions()
                this.getSelectedModulesSet()

                // Initialize mobile permissions if editing existing role
                if (!this.props.isAdd && this.props.editRoleData && this.props.editRoleData.adminMobileAppPermissions) {
                    this.setState({
                        selectedMobilePermissions: new Set(this.props.editRoleData.adminMobileAppPermissions),
                        adminMobileAppPermissions: this.props.editRoleData.adminMobileAppPermissions
                    });
                }
            });
        }

    }


    getSelectedModulesSet = () => {

        if (this.state.permissionsMasterList1 && Array.isArray(this.state.permissionsMasterList1) && this.state.permissionsMasterList1.length > 0) {

            let result = this.extractPermissionIds(this.state.isAdd, this.state.editModules, this.state.permissionsMasterList1, this.state.permissionIds)
            if (result) {
                this.getSelectedModulesData()
            }


        }


    }

    getSelectedModulesData = () => {

        const transformedData = Array.isArray(this.state.permissionsMasterList1) && this.state.permissionsMasterList1.length > 0
            ? this.state.permissionsMasterList1.flatMap(group =>
                group.permissions.map(permission => ({

                    groupName: group.groupName,
                    subFeature: permission.name,
                    subModule: permission.category,
                    id: permission.id,
                    groupId: group.id,
                    _id: group._id
                }))
            )
            : [];
        if (!this.props.isAdd && Array.isArray(this.state.permissionsMasterList1) && this.state.permissionsMasterList1.length > 0) {
            this.state.permissionsMasterList1.forEach(group =>
                group.permissions.forEach(permission => {
                    this.handleCheckBoxClick(group.id, permission.id, true);
                })
            );
        }
        console.log(transformedData);
        const filterData = Array.isArray(transformedData) && transformedData.length > 0 && Array.isArray(this.state.permissionIds) && this.state.permissionIds.length > 0
            ? transformedData.filter(item => {

                const isInSelectedValue = this.state.permissionIds.includes(item.groupId);
                return isInSelectedValue;
            })
            : [];


        this.setState({
            filterData: filterData,
        },
            () => {
                if (this.state.permissionIds && this.state.filterData) {

                    this.filterObjectByKeys(this.state.permissionIds, this.state.permissions)


                }

            });
    }


    filterObjectByKeys(keys, obj) {
        let filteredObj = {};

        keys.forEach(key => {
            if (obj[key]) {
                filteredObj[key] = obj[key];
            }
        });
        this.setState({
            permissions: filteredObj
        }, () => {
        });
        return filteredObj;
    }

    isChecked = (id, permissions, permissionIds) => {


        return Object.keys(permissions)?.reduce((acc, curr) => {
            acc = acc.concat(permissions[curr]);
            return acc;
        }, []).includes(id);


    };

    handleCheckBoxClick = (groupId, permissionId, checked) => {

        const permissionList = this.state.permissions;
        if (Object.keys(permissionList).includes(groupId)) {
            if (checked) {
                permissionList[groupId].push(permissionId);
            } else {
                permissionList[groupId] = permissionList[groupId].filter((item) => item !== permissionId);
                if (permissionList[groupId].length === 0) {
                    delete permissionList[groupId];
                }
            }
        } else {
            permissionList[groupId] = [permissionId];
        }

        this.setState((prevState) => {

            return {
                permissions: permissionList,
                errors: {
                    ...prevState.errors,
                    permissions: Object.keys(permissionList).length === 0
                }
            };
        });
    };
    handleCheckBoxChange = (groupId, permissionId, permissionIds) => (event) => {

        this.handleCheckBoxClick(groupId, permissionId, event.target.checked);
    };


    getSummaryReport = (pList, roleInfo) => {
        let summary = {
            roleName: roleInfo.roleName,
            description: roleInfo.description,
            roleType: roleInfo.roleType,
            permissions: [
            ]
        };
        pList.forEach(permission => {
            let perm = {
                groupName: permission.groupName,
                totalPermissions: permission.permissions.length,
                assignedPermissions: 0
            };

            if (roleInfo && roleInfo.permissions && roleInfo.permissions[permission.id] && roleInfo.permissions[permission.id].permissions) {
                perm.assignedPermissions = roleInfo.permissions[permission.id].permissions.length
            }

            summary.permissions.push(perm);

        }
        );
        return summary;
    }
    onMultiChange = (e, permission, permissionIds) => {
        this.setState((prevState) => {
            return {
                permissionIds: e.value,
            };
        }, () => {
            this.getSelectedModulesData()

        });
        ;
    }


    getLabelOptions = () => {
        const options = this.props.permissionsMasterList && this.props.permissionsMasterList?.map(obj => ({
            value: obj.id,
            label: obj.groupName.toUpperCase()
        })) || [];

        this.setState((prevState) => {

            return {
                labelOptions: options,
            };
        });

    }

    extractPermissionIds = (isAdd, editModules, permissionsMasterList1, permissionIdsSelected) => {

        let permissionIds = permissionIdsSelected;

        if (isAdd !== undefined && isAdd) {
            permissionsMasterList1.forEach((data, index) => {

                const matchedData = editModules.find(edit => edit.id === data.id);
                if (matchedData) {


                    permissionIds.push(matchedData.id);
                }
            });


        } else {
            let ids = permissionsMasterList1[0]?.id;
            if (!permissionIds.includes(ids)) {

                permissionIds.push(ids);
            }
        }

        return permissionIds;
    }

    // Mobile Permissions Methods
    handleMobilePermissionToggle = (featureId, isChecked) => {
        const newSelectedPermissions = new Set(this.state.selectedMobilePermissions);

        if (isChecked) {
            newSelectedPermissions.add(featureId);

            // Auto-enable "Mark Attendance" when "Attendance" is selected
            if (featureId === 'attendance') {
                newSelectedPermissions.add('mark_attendance');
            }
        } else {
            newSelectedPermissions.delete(featureId);

            // Remove sub-features when parent feature is unchecked
            if (featureId === 'attendance') {
                newSelectedPermissions.delete('mark_attendance');
            }
        }

        this.setState({ selectedMobilePermissions: newSelectedPermissions });
    }

    handleSubFeatureToggle = (subFeatureId, isChecked) => {
        const newSelectedPermissions = new Set(this.state.selectedMobilePermissions);

        if (isChecked) {
            newSelectedPermissions.add(subFeatureId);
        } else {
            newSelectedPermissions.delete(subFeatureId);
        }

        this.setState({ selectedMobilePermissions: newSelectedPermissions });
    }

    openMobilePermissionsModal = () => {
        this.setState({ showMobilePermissionsModal: true });
    }

    closeMobilePermissionsModal = () => {
        this.setState({
            showMobilePermissionsModal: false,
            isModalMaximized: false
        });
    }

    toggleSection = (sectionName) => {
        this.setState(prevState => ({
            expandedSections: {
                ...prevState.expandedSections,
                [sectionName]: !prevState.expandedSections[sectionName]
            }
        }));
    }

    getSelectedPermissionsSummary = () => {
        const selectedPermissions = [];
        const selectedIds = Array.from(this.state.selectedMobilePermissions);

        mobileFeatures.forEach(category => {
            category.features.forEach(feature => {
                if (selectedIds.includes(feature.id)) {
                    let featureText = feature.name;

                    // Check for sub-features
                    if (feature.hasSubFeatures && feature.subFeatures) {
                        const selectedSubFeatures = feature.subFeatures.filter(sub =>
                            selectedIds.includes(sub.id)
                        );
                        if (selectedSubFeatures.length > 0) {
                            featureText += ` (${selectedSubFeatures.map(sub => sub.name).join(', ')})`;
                        }
                    }

                    selectedPermissions.push(featureText);
                }
            });
        });

        return selectedPermissions;
    }

    saveMobilePermissions = () => {
        if (this.state.selectedMobilePermissions.size === 0) {
            return this.toast.show({
                severity: 'warn',
                summary: 'No Permissions Selected',
                detail: 'Please select at least one mobile permission before saving',
                life: 3000
            });
        }

        this.setState({
            showMobilePermissionsModal: false,
            adminMobileAppPermissions: Array.from(this.state.selectedMobilePermissions),
            isModalMaximized: false
        });
        this.toast.show({
            severity: 'success',
            summary: 'Mobile Permissions Updated',
            detail: 'Mobile app permissions have been configured successfully, Save the role changes to apply',
            life: 3000
        });
    }

    // Select All functionality for categories
    handleSelectAllCategory = (categoryName) => {
        const category = mobileFeatures.find(cat => cat.category === categoryName);
        if (!category) return;

        const newSelectedPermissions = new Set(this.state.selectedMobilePermissions);

        // Get all feature IDs and sub-feature IDs for this category
        const allFeatureIds = [];
        category.features.forEach(feature => {
            allFeatureIds.push(feature.id);
            if (feature.hasSubFeatures && feature.subFeatures) {
                feature.subFeatures.forEach(subFeature => {
                    allFeatureIds.push(subFeature.id);
                });
            }
        });

        // Add all features to selection
        allFeatureIds.forEach(id => newSelectedPermissions.add(id));

        this.setState({ selectedMobilePermissions: newSelectedPermissions });
    }

    handleDeselectAllCategory = (categoryName) => {
        const category = mobileFeatures.find(cat => cat.category === categoryName);
        if (!category) return;

        const newSelectedPermissions = new Set(this.state.selectedMobilePermissions);

        // Get all feature IDs and sub-feature IDs for this category
        const allFeatureIds = [];
        category.features.forEach(feature => {
            allFeatureIds.push(feature.id);
            if (feature.hasSubFeatures && feature.subFeatures) {
                feature.subFeatures.forEach(subFeature => {
                    allFeatureIds.push(subFeature.id);
                });
            }
        });

        // Remove all features from selection
        allFeatureIds.forEach(id => newSelectedPermissions.delete(id));

        this.setState({ selectedMobilePermissions: newSelectedPermissions });
    }

    // Check if all features in a category are selected
    isCategoryFullySelected = (categoryName) => {
        const category = mobileFeatures.find(cat => cat.category === categoryName);
        if (!category) return false;

        const allFeatureIds = [];
        category.features.forEach(feature => {
            allFeatureIds.push(feature.id);
            if (feature.hasSubFeatures && feature.subFeatures) {
                feature.subFeatures.forEach(subFeature => {
                    allFeatureIds.push(subFeature.id);
                });
            }
        });

        return allFeatureIds.every(id => this.state.selectedMobilePermissions.has(id));
    }

    // Check if any features in a category are selected
    isCategoryPartiallySelected = (categoryName) => {
        const category = mobileFeatures.find(cat => cat.category === categoryName);
        if (!category) return false;

        const allFeatureIds = [];
        category.features.forEach(feature => {
            allFeatureIds.push(feature.id);
            if (feature.hasSubFeatures && feature.subFeatures) {
                feature.subFeatures.forEach(subFeature => {
                    allFeatureIds.push(subFeature.id);
                });
            }
        });

        const selectedCount = allFeatureIds.filter(id => this.state.selectedMobilePermissions.has(id)).length;
        return selectedCount > 0 && selectedCount < allFeatureIds.length;
    }

    // Global Select All functionality
    handleSelectAllPermissions = () => {
        const newSelectedPermissions = new Set();

        mobileFeatures.forEach(category => {
            category.features.forEach(feature => {
                newSelectedPermissions.add(feature.id);
                if (feature.hasSubFeatures && feature.subFeatures) {
                    feature.subFeatures.forEach(subFeature => {
                        newSelectedPermissions.add(subFeature.id);
                    });
                }
            });
        });

        this.setState({ selectedMobilePermissions: newSelectedPermissions });
    }

    handleDeselectAllPermissions = () => {
        this.setState({ selectedMobilePermissions: new Set() });
    }

    // Check if all permissions are selected globally
    areAllPermissionsSelected = () => {
        return mobileFeatures.every(category => this.isCategoryFullySelected(category.category));
    }

    // Check if any permissions are selected globally
    areAnyPermissionsSelected = () => {
        return this.state.selectedMobilePermissions.size > 0;
    }


    // handleSelectAllChange = (e) => {
    //     const checked = e.target.checked;
    //     const allPermissionIds = this.props.filterData.map(item => item.id);

    //     this.setState({
    //         selectAll: checked,
    //         selectedPermissions: checked ? allPermissionIds : [] // Select all or clear selection
    //     });
    // }

    // handleCheckBoxChange = (groupId, id) => (e) => {
    //     const checked = e.target.checked;
    //     let selectedPermissions = [...this.state.selectedPermissions];

    //     if (checked) {
    //         selectedPermissions.push(id);
    //     } else {
    //         selectedPermissions = selectedPermissions.filter(item => item !== id);
    //     }

    //     this.setState({ selectedPermissions });
    // }

    render() {


        const { role, formValidations, permissions, permissionIds, filterData, labelOptions } = this.state;
        const groupIds = Array.from(new Set(filterData.map(item => item.groupId)));

        return (
            <>
                <div className=' grid col-12  mt-4'>

                    <div className='grid col-12'>
                        <div className="col-3">
                            <p className='ma-label-s2 formLabelText'>Role Name<span className='ma-required'>*</span></p>

                            <ClassetInputText
                                // icon={<MailIcon />}
                                placeholder={'Role Name'} value={role.roleName} onChange={(e) => { onTextChange(e.target.value, 'roleName', this, createRoleFields, role, formValidations, 'role', 'formValidations') }} />



                            {formValidations && !formValidations.fields['roleName'].isValid && <p className="p-error font-semibold">{formValidations.fields['roleName'].errorMsg}</p>}

                        </div>

                        <div className="col-9">
                            <p className='ma-label-s2 formLabelText'>Role Description<span className='ma-required'>*</span></p>

                            <ClassetInputText width={'100%'} height={"49px"} value={role.description} onChange={(e) => { onTextChange(e.target.value, 'description', this, createRoleFields, role, formValidations, 'role', 'formValidations') }} placeholder="Role Description" />
                            {formValidations && !formValidations.fields['description'].isValid && <p className="p-error">{formValidations.fields['description'].errorMsg}</p>}

                        </div>
                    </div>

                    <p className='mainHead text-3xl'>Permissions</p>
                    <div className='grid col-12'>

                        <div className='col-3 '>
                            <p className='ma-label-s2 formLabelText'>Select Modules<span className='ma-required'>*</span></p>
                            <ClassetMultiSelect
                                // icon={<MailIcon />}
                                placeholder='Select Modules'
                                value={permissionIds.length > 0 ? permissionIds : []}
                                onChange={(e) => this.onMultiChange(e, permissions, permissionIds)}
                                options={labelOptions}
                            />
                            {/* {formValidations && !formValidations.fields['groupName'].isValid && <p className="p-error">{formValidations.fields['groupName'].errorMsg}</p>}  */}


                        </div>

                        <div className="col-3">
                            <p className='ma-label-s2 formLabelText'>Type<span className='ma-required'>*</span></p>

                            <ClassetDropdown


                                // icon={<MailIcon />}
                                placeholder={'Type'}
                                options={TemplateTypes}
                                value={role?.type}
                                onChange={(e) => {
                                    onDropDownChange(e.value, 'type', this, createRoleFields, role, formValidations, 'role', 'formValidations')
                                }}
                            />
                            {formValidations && !formValidations.fields['type'].isValid && <p className="p-error">{formValidations.fields['type'].errorMsg}</p>}

                        </div>

                        <div className="col-3">
                            <p className='ma-label-s2 formLabelText'>Mobile App Permissions<span className='ma-required'>*</span></p>
                            <Button
                                className='submitButton'
                                onClick={this.openMobilePermissionsModal}
                                style={{ height: '49px' }}

                            >
                                <p className=''>Manage Mobile Permissions</p>
                            </Button>

                            {this.state.selectedMobilePermissions.size > 0 ? (
                                <small style={{ color: '#10b981', fontWeight: '600', marginTop: '4px', display: 'block' }}>
                                    ✓ {this.state.selectedMobilePermissions.size} permission(s) configured
                                </small>
                            ) : (
                                <small style={{ color: '#dc2626', fontWeight: '600', marginTop: '4px', display: 'block' }}>
                                    ⚠ Mobile permissions required
                                </small>
                            )}
                        </div>

                        <div className="col-3">
                            <div className="text-center mt-5 ml-3">
                            {/* <p className='ma-label-s2 formLabelText'><span className='ma-required'></span></p> */}


                                <Button className='submitButton'
                                    style={{ marginTop: '0px', height: '49px', marginBottom: '10px', maxWidth: '150px', position: 'absolute', right: '100px' }}
                                    onClick={this.onSubmitClick}

                                >
                                    <p className='submitButtonText'>{`${this.props.isAdd ? 'Update' : 'Save'}`}</p>
                                </Button>

                                {/* <Button
                                className="cancelButton"

                                onClick={() => { this.props.showEditRoleDialog(null, null, false); this.props.onTabChange(0); }}>
                                <p className='cancelButtonText'>Cancel</p>

                            </Button> */}

                            </div>
                        </div>


                    </div>

                    <div className=' col-12 card ml-3 mt-3 '>
                        <DataTable ref={(el) => this.dt = el}
                            responsiveLayout="scroll"
                            className="datatable-cell"

                            value={filterData.length > 0 && filterData} >


                            <Column header='Module' headerClassName="datatable-header" sortable filterField="groupName" field="groupName" className='col-4'
                            />

                            <Column header="Sub Module" headerClassName="datatable-header" sortable className='col-4' filterField="subModule" field="subModule" />

                            <Column header="Feature" headerClassName="datatable-header" sortable filterField="subFeature" field="subFeature" />
                            <Column header="Enabled" headerClassName="datatable-header" sortable filterField="id" field="id" className='col-1' body={(rowData, index) => {
                                return (
                                    <Checkbox inputId={rowData.id}
                                        checked={this.isChecked(rowData.id, permissions, permissionIds)}
                                        value={rowData.id}
                                        onChange={this.handleCheckBoxChange(rowData.groupId, rowData.id)}
                                    ></Checkbox>
                                )
                            }} />



                        </DataTable>
                    </div>



                    {/* <div className="text-center mt-4 ml-3">
                        <div className="button-wrapper">

                            <Button className='submitButton'
                                onClick={this.onSubmitClick}

                            >
                                <p className='submitButtonText'>{`${this.props.isAdd ? 'Update' : 'Save'}`}</p>
                            </Button>

                             <Button
                                className="cancelButton"

                                onClick={() => { this.props.showEditRoleDialog(null, null, false); this.props.onTabChange(0); }}>
                                <p className='cancelButtonText'>Cancel</p>

                            </Button> 

                        </div>
                    </div> */}


                </div>

                {
                    this.state.isLoading && <>
                        <LoadingComponent />
                    </>
                }

                {/* Mobile Permissions Modal */}
                <Dialog
                    header={
                        <div>
                            <h3 style={{ margin: 0, color: '#1f2937', fontSize: '20px' }}>
                                Assign Mobile Permissions for "{role.roleName || 'New Role'}"
                            </h3>
                            <p style={{ margin: '8px 0 0 0', color: '#6b7280', fontSize: '14px' }}>
                                Select the mobile features this role can view in the Admin Mobile app.
                            </p>
                        </div>
                    }
                    visible={this.state.showMobilePermissionsModal}
                    // style={{ 
                    //     width: this.state.isModalMaximized ? '95vw' : '65vw', 
                    //     minWidth: '600px', 
                    //     maxWidth: this.state.isModalMaximized ? '95vw' : '900px',
                    //     height: this.state.isModalMaximized ? '90vh' : 'auto'
                    // }}
                    modal
                    draggable={!this.state.isModalMaximized}
                    closable={true}
                    // maximizable
                    onMaximize={() => this.setState({ isModalMaximized: true })}
                    onHide={this.closeMobilePermissionsModal}
                    footer={() => {
                        const selectedSummary = this.getSelectedPermissionsSummary();
                        return (
                            <div style={{ padding: this.state.isModalMaximized ? '20px 0 12px 0' : '16px 0 8px 0' }}>
                                {selectedSummary.length > 0 && (
                                    <div style={{
                                        background: '#f3f4f6',
                                        padding: this.state.isModalMaximized ? '16px' : '12px',
                                        borderRadius: '6px',
                                        marginBottom: '16px',
                                        border: '1px solid #e5e7eb'
                                    }}>
                                        <p style={{
                                            margin: '0 0 8px 0',
                                            fontWeight: '600',
                                            color: '#374151',
                                            fontSize: this.state.isModalMaximized ? '16px' : '14px'
                                        }}>
                                            Selected Permissions Preview:
                                        </p>
                                        <p style={{
                                            margin: 0,
                                            color: '#6b7280',
                                            fontSize: this.state.isModalMaximized ? '14px' : '13px',
                                            lineHeight: '1.4'
                                        }}>
                                            {selectedSummary.join(', ')}
                                        </p>
                                    </div>
                                )}
                                <div className="flex justify-content-center gap-3">
                                    <Button
                                        className="formCancelButton px-4"
                                        onClick={this.closeMobilePermissionsModal}
                                        style={{
                                            height: this.state.isModalMaximized ? '45px' : '40px',
                                            fontSize: this.state.isModalMaximized ? '15px' : '14px'
                                        }}
                                    >
                                        <p className="formCancelButtonText">Cancel</p>
                                    </Button>
                                    <Button
                                        className="formSubmitButton px-4"
                                        onClick={this.saveMobilePermissions}
                                        style={{
                                            height: this.state.isModalMaximized ? '45px' : '40px',
                                            fontSize: this.state.isModalMaximized ? '15px' : '14px'
                                        }}
                                    >
                                        <p className="formSubmitButtonText">Save Permissions</p>
                                    </Button>
                                </div>
                            </div>
                        );
                    }}
                >
                    <div
                        className="mobile-permissions-content"
                        style={{
                            height: this.state.isModalMaximized ? '75vh' : '65vh',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            padding: '8px 16px'
                        }}
                    >
                        {/* Global Select All Controls */}
                        <div style={{
                            background: '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div>
                                <h5 style={{
                                    margin: '0 0 4px 0',
                                    fontSize: this.state.isModalMaximized ? '15px' : '14px',
                                    fontWeight: '600',
                                    color: '#1e293b'
                                }}>
                                    Quick Actions
                                </h5>
                                <p style={{
                                    margin: 0,
                                    fontSize: this.state.isModalMaximized ? '13px' : '12px',
                                    color: '#64748b'
                                }}>
                                    Select or deselect all permissions at once
                                </p>
                            </div>

                            <div className="flex align-items-center gap-3">
                                <Button
                                    className="p-button-outlined p-button-sm"
                                    onClick={this.handleSelectAllPermissions}
                                    disabled={this.areAllPermissionsSelected()}
                                    style={{
                                        fontSize: this.state.isModalMaximized ? '13px' : '12px',
                                        padding: '6px 12px',
                                        height: 'auto'
                                    }}
                                >
                                    <i className="pi pi-check-square mr-2"></i>
                                    Select All
                                </Button>

                                <Button
                                    className="p-button-outlined p-button-sm p-button-danger"
                                    onClick={this.handleDeselectAllPermissions}
                                    disabled={!this.areAnyPermissionsSelected()}
                                    style={{
                                        fontSize: this.state.isModalMaximized ? '13px' : '12px',
                                        padding: '6px 12px',
                                        height: 'auto'
                                    }}
                                >
                                    <i className="pi pi-times mr-2"></i>
                                    Clear All
                                </Button>
                            </div>
                        </div>

                        <div className={`grid ${this.state.isModalMaximized ? 'gap-4' : ''}`}>
                            {mobileFeatures.map((category, categoryIndex) => {
                                const isExpanded = this.state.expandedSections[category.category];
                                return (
                                    <div
                                        key={categoryIndex}
                                        className={`mb-4 ${this.state.isModalMaximized ? 'col-6' : 'col-12'}`}
                                        style={{
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '8px',
                                            height: 'fit-content'
                                        }}
                                    >
                                        {/* Category Header - Collapsible */}
                                        <div
                                            className="cursor-pointer"
                                            style={{
                                                background: '#f9fafb',
                                                padding: '16px',
                                                borderBottom: isExpanded ? '1px solid #e5e7eb' : 'none'
                                            }}
                                        >
                                            <div className="flex align-items-center justify-content-between">
                                                <div className="flex align-items-center flex-1" onClick={() => this.toggleSection(category.category)}>
                                                    <div>
                                                        <h4 style={{
                                                            margin: '0 0 4px 0',
                                                            fontSize: this.state.isModalMaximized ? '18px' : '16px',
                                                            fontWeight: '600',
                                                            color: '#1f2937'
                                                        }}>
                                                            {category.category}
                                                        </h4>
                                                        <p style={{
                                                            margin: 0,
                                                            fontSize: this.state.isModalMaximized ? '14px' : '13px',
                                                            color: '#6b7280'
                                                        }}>
                                                            {category.description}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="flex align-items-center gap-3">
                                                    {/* Select All Checkbox */}
                                                    <div className="flex align-items-center" onClick={(e) => e.stopPropagation()}>
                                                        <Checkbox
                                                            inputId={`selectAll_${category.category.replace(/\s+/g, '_')}`}
                                                            checked={this.isCategoryFullySelected(category.category)}
                                                            indeterminate={this.isCategoryPartiallySelected(category.category)}
                                                            onChange={(e) => {
                                                                if (e.checked) {
                                                                    this.handleSelectAllCategory(category.category);
                                                                } else {
                                                                    this.handleDeselectAllCategory(category.category);
                                                                }
                                                            }}
                                                            style={{
                                                                marginRight: '6px',
                                                                transform: this.state.isModalMaximized ? 'scale(1.1)' : 'scale(1)'
                                                            }}
                                                        />
                                                        <label
                                                            htmlFor={`selectAll_${category.category.replace(/\s+/g, '_')}`}
                                                            className="cursor-pointer"
                                                            style={{
                                                                fontSize: this.state.isModalMaximized ? '13px' : '12px',
                                                                color: '#6366f1',
                                                                fontWeight: '500',
                                                                margin: 0
                                                            }}
                                                        >
                                                            Select All
                                                        </label>
                                                    </div>

                                                    {/* Expand/Collapse Icon */}
                                                    <div onClick={() => this.toggleSection(category.category)}>
                                                        <i className={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`}
                                                            style={{ fontSize: '14px', color: '#6b7280' }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Category Content */}
                                        {isExpanded && (
                                            <div style={{
                                                padding: this.state.isModalMaximized ? '20px' : '16px'
                                            }}>
                                                {category.features.map((feature, featureIndex) => (
                                                    <div key={feature.id} className="mb-4" style={{
                                                        paddingBottom: this.state.isModalMaximized ? '20px' : '16px',
                                                        borderBottom: featureIndex < category.features.length - 1 ? '1px solid #f3f4f6' : 'none'
                                                    }}>
                                                        <div className="flex align-items-start">
                                                            <Checkbox
                                                                inputId={feature.id}
                                                                checked={this.state.selectedMobilePermissions.has(feature.id)}
                                                                onChange={(e) => this.handleMobilePermissionToggle(feature.id, e.checked)}
                                                                style={{
                                                                    marginTop: '2px',
                                                                    transform: this.state.isModalMaximized ? 'scale(1.1)' : 'scale(1)'
                                                                }}
                                                            />
                                                            <div className="ml-3 flex-1">
                                                                <label
                                                                    htmlFor={feature.id}
                                                                    className="cursor-pointer"
                                                                    style={{
                                                                        fontSize: this.state.isModalMaximized ? '16px' : '14px',
                                                                        fontWeight: '500',
                                                                        color: '#374151',
                                                                        display: 'block',
                                                                        marginBottom: this.state.isModalMaximized ? '6px' : '4px'
                                                                    }}
                                                                >
                                                                    {feature.name}
                                                                </label>
                                                                <p style={{
                                                                    margin: 0,
                                                                    fontSize: this.state.isModalMaximized ? '13px' : '12px',
                                                                    color: '#6b7280',
                                                                    lineHeight: '1.4'
                                                                }}>
                                                                    {feature.description}
                                                                </p>

                                                                {/* Sub-features */}
                                                                {feature.hasSubFeatures && feature.subFeatures &&
                                                                    this.state.selectedMobilePermissions.has(feature.id) && (
                                                                        <div style={{
                                                                            marginTop: this.state.isModalMaximized ? '16px' : '12px',
                                                                            paddingLeft: this.state.isModalMaximized ? '24px' : '20px',
                                                                            borderLeft: '2px solid #e5e7eb'
                                                                        }}>
                                                                            {feature.subFeatures.map((subFeature) => (
                                                                                <div key={subFeature.id} className="flex align-items-start mb-2">
                                                                                    <Checkbox
                                                                                        inputId={subFeature.id}
                                                                                        checked={this.state.selectedMobilePermissions.has(subFeature.id)}
                                                                                        onChange={(e) => this.handleSubFeatureToggle(subFeature.id, e.checked)}
                                                                                        style={{
                                                                                            marginTop: '2px',
                                                                                            transform: this.state.isModalMaximized ? 'scale(1.1)' : 'scale(1)'
                                                                                        }}
                                                                                    />
                                                                                    <div className="ml-2 flex-1">
                                                                                        <label
                                                                                            htmlFor={subFeature.id}
                                                                                            className="cursor-pointer"
                                                                                            style={{
                                                                                                fontSize: this.state.isModalMaximized ? '14px' : '13px',
                                                                                                color: '#374151',
                                                                                                display: 'block',
                                                                                                marginBottom: '2px'
                                                                                            }}
                                                                                        >
                                                                                            {subFeature.name}

                                                                                        </label>
                                                                                        <p style={{
                                                                                            margin: 0,
                                                                                            fontSize: this.state.isModalMaximized ? '12px' : '11px',
                                                                                            color: '#6b7280',
                                                                                            lineHeight: '1.3'
                                                                                        }}>
                                                                                            {subFeature.description}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        {this.state.selectedMobilePermissions.size === 0 && (
                            <div className="text-center py-5" style={{
                                background: '#fef3f2',
                                border: '2px dashed #f87171',
                                borderRadius: '8px',
                                margin: '20px 0'
                            }}>
                                <i className="pi pi-exclamation-triangle" style={{
                                    fontSize: this.state.isModalMaximized ? '32px' : '24px',
                                    color: '#dc2626',
                                    marginBottom: '8px'
                                }}></i>
                                <p style={{
                                    color: '#dc2626',
                                    margin: '0 0 4px 0',
                                    fontSize: this.state.isModalMaximized ? '16px' : '14px',
                                    fontWeight: '600'
                                }}>
                                    Mobile Permissions Required
                                </p>
                                <p style={{
                                    color: '#7f1d1d',
                                    margin: 0,
                                    fontSize: this.state.isModalMaximized ? '14px' : '12px'
                                }}>
                                    Please select at least one mobile feature to complete role configuration.
                                </p>
                            </div>
                        )}
                    </div>
                </Dialog>

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>
        )
    }
}
const mapStateToProps = (state) => ({

});
const mapDispatchToProps = (dispatch) => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(CreateRoleManagement);
